import React, { FC } from 'react'
import shareImg from './affiliates-share.gif'
import copyLinkImg from './affiliates-copy-link.gif'
import getPaidImg from './affiliates-get-paid.gif'
import { StyledWorks } from '.'

const Works: FC = () => {
  return (
    <StyledWorks>
      <div className="heading">
        <h2>How it Works</h2>
        <p>
          It's easy to earn as a Social Curator Affiliate! Follow the steps below to get started
          today.
        </p>
      </div>

      <div className="work-steps">
        <div className="work-step-container">
          <div className="work-step">
            <div className="work-step-number">
              <span>1</span>
            </div>
            <span className="work-step-title">
              Start earning by <mark>copying your link</mark> to one of the offers below.
            </span>
          </div>
          <div className="work-step-image">
            <img src={shareImg} alt="" />
          </div>
        </div>

        <div className="work-step-container">
          <div className="work-step">
            <div className="work-step-number">
              <span>2</span>
            </div>
            <span className="work-step-title">
              <mark>Share your link on social media</mark>, in newsletters, blog posts, and more.
            </span>
            <span className="work-step-description">
              For done-for-you promotional materials, check out our affiliate resources here!
            </span>
          </div>
          <div className="work-step-image">
            <img src={copyLinkImg} alt="" />
          </div>
        </div>

        <div className="work-step-container">
          <div className="work-step">
            <div className="work-step-number">
              <span>3</span>
            </div>
            <span className="work-step-title">
              Receive your <mark>automatic payout on the first day</mark> of the following month!
            </span>
            <span className="work-step-description">
              You'll receive a one-time payout every time a business owner uses your link to start a
              subscription or purchases a course!
            </span>
          </div>
          <div className="work-step-image">
            <img src={getPaidImg} alt="" />
          </div>
        </div>
      </div>
    </StyledWorks>
  )
}

export default Works
